import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import ReactLoading from "react-loading";
import { formatDate } from "../../../../../../utils/commonFunctions";
import { Card, message, Modal } from "antd";
import swal from "sweetalert";
import {
  hasNumeric,
  hasSpecialCharacter,
  isNameValid,
  isValidAddress,
} from "./commonfunctions";
import useAxios from "../../../../../../hooks/useAxios";

function EPF({
  form,
  filledForm,
  getAllJoiningFilledForms,
  aadharDetails,
  metaData,
  setEPFPreviewData,
  setActivePanel,
  application,
  nomineeGratuity,
  nomineeWages,
  setIsFieldTouch,
}) {
  let prefilledNominees = null;

  if (nomineeGratuity && !prefilledNominees) {
    if (nomineeGratuity?.documentDetails?.useNominee) {
      if (nomineeGratuity?.documentDetails?.nominees?.length !== 0) {
        prefilledNominees = nomineeGratuity?.documentDetails?.nominees?.map(
          (ele) => ({
            name_and_address_of_nominee: ele?.name_of_nominee,
            nominee_relationship: ele?.relationship,
            date_of_birth: "",
            total_amount: Number(ele?.total_amount),
          })
        );
      }
    }
  }
  if (nomineeWages && !prefilledNominees) {
    if (nomineeWages?.documentDetails?.useNominee) {
      if (nomineeWages?.documentDetails?.nominees?.length !== 0) {
        prefilledNominees = nomineeWages?.documentDetails?.nominees?.map(
          (ele) => ({
            name_and_address_of_nominee: `${ele?.name_of_nominee}, ${ele?.address}`,
            nominee_relationship: ele?.nominee_relationship,
            date_of_birth: ele?.date_of_birth,
            total_amount: ele?.total_amount,
          })
        );
      }
    }
  }

  let row = 0;
  const IS_DISABLE =
    filledForm?.formStatusByHR === false
      ? !application?.candidateSignatureStatus
        ? true
        : false
      : false;
  let _aadhar = aadharDetails || {};
  const { house, street, state, loc, dist } =
    _aadhar?.aadharVerificationDetails?.data?.address || {};

  const ADDRESS =
    _aadhar?.aadharVerificationDetails?.data?.full_address ||
    [house, street, state, loc, dist].filter(Boolean).join(", ") ||
    "";

  const DOB = application?.responses?.find(
    (item) => item?.label === "Date of Birth"
  )?.value;

  const AADHAR_GENDER = _aadhar?.aadharVerificationDetails?.data?.gender || "";

  const FORM_GENDER =
    application?.responses?.find((item) => item?.label === "Gender")?.value ||
    "";

  const GENDER = AADHAR_GENDER
    ? AADHAR_GENDER === "M"
      ? "male"
      : AADHAR_GENDER === "F"
      ? "female"
      : ""
    : FORM_GENDER
    ? FORM_GENDER?.toLowerCase()
    : "";

  const [useNominee, setUseNominee] = useState(
    filledForm?.documentDetails?.useNominee ? true : false
  );

  const api = useAxios();
  const { id } = useParams();
  const [nominees, setNominees] = useState(
    !filledForm?.documentDetails
      ? prefilledNominees
        ? [...prefilledNominees]
        : [
            {
              name_and_address_of_nominee: "",
              nominee_relationship: "",
              total_amount: "",
              date_of_birth: "",
            },
          ]
      : [...filledForm?.documentDetails?.nominees]
  );
  const [nomineeError, setNomineeError] = useState({});

  const [formData, setFormData] = useState({
    name:
      filledForm?.documentDetails?.name ||
      _aadhar?.aadharVerificationDetails?.data?.full_name ||
      (metaData?.first_name || metaData?.last_name
        ? `${metaData?.first_name} ${metaData?.last_name}`
        : undefined) ||
      "",
    dob:
      filledForm?.documentDetails?.dob ||
      _aadhar?.aadharVerificationDetails?.data?.dob ||
      DOB ||
      "",
    father_name:
      filledForm?.documentDetails?.father_name ||
      metaData?.father_name?.trim() ||
      _aadhar?.aadharVerificationDetails?.data?.care_of
        ?.replace(/^[A-Za-z]+\/[A-Za-z]+:?\s+/i, "")
        .trim() ||
      "",
    marital_status:
      filledForm?.documentDetails?.marital_status ||
      (metaData?.marital_status?.toLowerCase() === "single"
        ? "unmarried"
        : metaData?.marital_status?.toLowerCase() === "widower"
        ? "widow"
        : metaData?.marital_status?.toLowerCase() || ""),
    sex:
      filledForm?.documentDetails?.sex ||
      GENDER ||
      metaData?.gender?.toLowerCase() ||
      "",
    permanent_address:
      filledForm?.documentDetails?.permanent_address ||
      (ADDRESS ? ADDRESS : undefined) ||
      metaData?.permanent_address ||
      "",
    temporary_address:
      filledForm?.documentDetails?.temporary_address ||
      metaData?.correspondence_address ||
      "",
    relation: filledForm?.documentDetails?.relation || "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({});

  const validateNominee = () => {
    for (let i = 0; i < nominees.length; i++) {
      let nominee = nominees[i];
      if (nominee) {
        let keys = Object.keys(nominee);
        for (let j = 0; j < keys.length; j++) {
          let key = keys[j];
          if (key !== "nominee_guardian_name_address" && nominee[key] === "") {
            return true;
          }
        }
      }
    }
    return false;
  };

  const addMore = (e) => {
    setNominees((prev) => {
      return [
        ...prev,
        {
          name_and_address_of_nominee: "",
          nominee_relationship: "",
          total_amount: "",
          date_of_birth: "",
        },
      ];
    });
  };

  const deleteNominee = (_index) => {
    setNominees((prev) => {
      let arr = [...prev];
      // arr.splice(_index,1)
      arr[_index] = null;
      const total = arr
        ?.filter((nom) => nom !== null)
        ?.reduce((acc, nom) => {
          if (nom) return (acc = acc + Number(nom?.total_amount || 0));
        }, 0);
      setTotalAmt(total);
      return [...arr];
    });

    for (let key in nomineeError) {
      if (key.endsWith(_index)) {
        delete nomineeError[key];
      }
    }
  };

  const handleChange = (e) => {
    setIsFieldTouch(true);
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const [totalAmt, setTotalAmt] = useState(0);

  useEffect(() => {
    let e = {};
    const total = nominees
      .filter((nom) => nom !== null)
      ?.reduce((acc, nom) => {
        if (nom) return (acc = acc + Number(nom?.total_amount || 0));
      }, 0);
    setTotalAmt(total);
  }, [nominees]);

  const handleChangeNominee = (e, _index) => {
    setIsFieldTouch(true);
    const { name, value } = e.target;
    setNominees((prev) => {
      let arr = [...prev];
      arr.forEach((item, index) => {
        if (index === _index) {
          item[name] = value;
        }
      });

      if (name === "total_amount") {
        const sum = arr
          ?.filter((nom) => nom !== null)
          ?.reduce((acc, nom) => {
            return (acc = acc + Number(nom?.total_amount));
          }, 0);
        setTotalAmt(sum);
      }
      if (name === "name_and_address_of_nominee") {
        if ((value && value.length < 3) || value.trim().length > 100) {
          setNomineeError({
            ...nomineeError,
            [`name_and_address_of_nominee_${_index}`]: {
              message: "This field must be more than 3 and less tha 100 char.",
              index: _index,
            },
          });
        } else {
          setNomineeError({
            ...nomineeError,
            [`name_and_address_of_nominee_${_index}`]: "",
          });
        }
      }

      if (name === "date_of_birth") {
        if (value && new Date() < new Date(value)) {
          setNomineeError({
            ...nomineeError,
            [`date_of_birth_${_index}`]: {
              message: "Future date is not allowed",
              index: _index,
            },
          });
        } else {
          setNomineeError({
            ...nomineeError,
            [`date_of_birth_${_index}`]: "",
          });
        }
      }

      if (name === "nominee_relationship") {
        if (hasNumeric(value) || hasSpecialCharacter(value)) {
          setNomineeError({
            ...nomineeError,
            [`nominee_relationship_${_index}`]: {
              message: "No numeric or special character allowed.",
              index: _index,
            },
          });
        } else {
          setNomineeError({
            ...nomineeError,
            [`nominee_relationship_${_index}`]: "",
          });
        }
      }

      return [...arr];
    });
  };

  const isFormDataEmpty = () => {
    for (let key in formData) {
      if (formData[key].trim() === "") {
        return true;
      }
    }
    return false;
  };

  const validateInput = (e) => {
    if (isFormDataEmpty()) {
      return true;
    }

    return false;
  };

  function getLastNonNullableIndex(array) {
    for (let i = array.length - 1; i >= 0; i--) {
      if (array[i] !== null && array[i] !== undefined) {
        return i;
      }
    }
    return -1;
  }

  useEffect(() => {
    setEPFPreviewData({ ...formData, nominees });

    let e = {};

    // if (formData?.name.trim()) {
    //   e.name = isNameValid(formData.name);
    // }

    // if (formData?.father_name?.trim()) {
    //   e.father_name = isNameValid(formData?.father_name);
    // }

    // if (formData.dob && new Date(formData.dob) > new Date()) {
    //   e.dob = "Future date is not allowed.";
    // } else {
    //   e.dob = "";
    // }

    // if (formData?.permanent_address.trim()) {
    //   e.permanent_address = isValidAddress(formData?.permanent_address);
    // }

    // if (formData?.temporary_address.trim()) {
    //   e.temporary_address = isValidAddress(formData?.temporary_address);
    // }

    if ((totalAmt < 100 || totalAmt > 100) && totalAmt !== 0) {
      const errorIndex = getLastNonNullableIndex(nominees);
      setNomineeError({
        ...nomineeError,
        total_amount: {
          message: `total amout must be equal to ${100}`,
          index: errorIndex,
        },
      });
    } else {
      setNomineeError({
        ...nomineeError,
        total_amount: "",
      });
    }

    setError({ ...error, ...e });
  }, [formData, nominees, totalAmt]);

  const checkNomineeError = () => {
    for (let key in nomineeError) {
      if (nomineeError[key] !== "") {
        return true;
      }
    }
    return false;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let flag = false;
    for (let key in error) {
      if (error[key] !== "") {
        flag = true;
        break;
      }
    }

    if (flag || checkNomineeError()) {
      swal({
        title: "Error",
        // text: "Are you sure you want to Approve? Before on-boarding the candidate, please cross verify the TRF.",
        icon: "error",
        content: {
          element: "div",
          attributes: {
            innerHTML: `
                  <p style="text-align:center">Before submit please resolve all the errors.</p>       
                `,
          },
        },
        buttons: {
          cancel: false,
          confirm: true,
        },
      }).then((flag) => {});
      return;
    }

    const data = {
      companyDocumentId: form?._id,
      candidateId: id,
      documentDetails: {
        useNominee,
        ...formData,
        nominees: [...nominees.filter((nom) => nom !== null)],
      },
      formStatus: true,
    };

    try {
      setLoading(true);
      await api.post(`/companyDocuments/DocumentMaping`, data, {
        tokenType: "candidate",
      });
      await getAllJoiningFilledForms();
      message.success("Your form has been submitted successfully!", 2);
      setActivePanel(null);
      setLoading(false);
      setIsFieldTouch(false);
    } catch (err) {
      setLoading(false);
    }
  };

  return (
    <>
      <Card>
        {loading ? (
          <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
        ) : (
          <div className="row">
            <div className="col-12">
              <p style={{ color: "red", fontSize: "14px" }}>
                <strong>Note:</strong> All fields marked with an asterisk (
                <span style={{ color: "red" }}>*</span>) are mandatory.
              </p>
            </div>
            <div className="col-12">
              <div className="row">
                <div className="form-group col-md-4 form-builder-element mb-3">
                  <label htmlFor="">
                    Name (in Block Letters)
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    className="form-control form-view"
                    type="text"
                    placeholder=""
                    disabled={filledForm?.formStatusByHR || true}
                    name="name"
                    onChange={handleChange}
                    style={{
                      ...(error?.name ? { border: "1px solid red" } : {}),
                    }}
                    value={formData?.name.replaceAll(/\b[a-z]/g, (p) =>
                      p.toUpperCase()
                    )}
                  />
                  {error?.name && (
                    <p style={{ color: "red", fontSize: "10px" }}>
                      {error?.name}
                    </p>
                  )}
                </div>
                <div className="form-group col-md-6 form-builder-element mb-3">
                  <div className="d-flex justify-content-between flex-wrap">
                    <label htmlFor="">
                      Father's / Husband's Name
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="form-group form-builder-element">
                      <div className="row">
                        <div className="custom-control custom-radio mx-3">
                          <input
                            id="epf_relation_father"
                            disabled={filledForm?.formStatusByHR}
                            name="relation"
                            type="checkbox"
                            className="custom-control-input form-view"
                            onChange={handleChange}
                            value="father"
                            checked={formData?.relation === "father"}
                          />
                          <label
                            htmlFor="epf_relation_father"
                            className="custom-control-label"
                          >
                            Father
                          </label>
                        </div>
                        <div className="custom-control custom-radio mx-3">
                          <input
                            disabled={filledForm?.formStatusByHR}
                            id="epf_relation_husband"
                            name="relation"
                            type="checkbox"
                            className="custom-control-input form-view"
                            onChange={handleChange}
                            value="husband"
                            checked={formData?.relation === "husband"}
                          />
                          <label
                            htmlFor="epf_relation_husband"
                            className="custom-control-label"
                          >
                            Husband
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <input
                    className="form-control form-view"
                    type="text"
                    placeholder=""
                    name="father_name"
                    disabled={filledForm?.formStatusByHR || true}
                    onChange={handleChange}
                    style={{
                      ...(error?.father_name
                        ? { border: "1px solid red" }
                        : {}),
                    }}
                    value={formData?.father_name.replaceAll(/\b[a-z]/g, (p) =>
                      p.toUpperCase()
                    )}
                  />
                  {error?.father_name && (
                    <p style={{ color: "red", fontSize: "10px" }}>
                      {error?.father_name}
                    </p>
                  )}
                </div>{" "}
                <div className="form-group col-md-4 form-builder-element mb-3">
                  <label htmlFor="">
                    Permanent Address
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    className="form-control form-view"
                    type="text"
                    placeholder=""
                    name="permanent_address"
                    disabled={filledForm?.formStatusByHR || true}
                    onChange={handleChange}
                    style={{
                      ...(error?.permanent_address
                        ? { border: "1px solid red" }
                        : {}),
                    }}
                    value={formData?.permanent_address}
                  />
                  {error?.permanent_address && (
                    <p style={{ color: "red", fontSize: "10px" }}>
                      {error?.permanent_address}
                    </p>
                  )}
                </div>
                <div className="form-group col-md-4 form-builder-element mb-3">
                  <label htmlFor="">
                    Temporary Address
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    className="form-control form-view"
                    type="text"
                    placeholder=""
                    name="temporary_address"
                    disabled={filledForm?.formStatusByHR || true}
                    min={0}
                    onChange={handleChange}
                    style={{
                      ...(error?.temporary_address
                        ? { border: "1px solid red" }
                        : {}),
                    }}
                    value={formData?.temporary_address}
                  />
                  {error?.temporary_address && (
                    <p style={{ color: "red", fontSize: "10px" }}>
                      {error?.temporary_address}
                    </p>
                  )}
                </div>
                <div className="form-group col-md-4 form-builder-element mb-3">
                  <label htmlFor="">
                    Date of Birth
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    className="form-control form-view"
                    type="date"
                    disabled={filledForm?.formStatusByHR || true}
                    name="dob"
                    max={formatDate(new Date())}
                    onChange={handleChange}
                    style={{
                      ...(error?.dob ? { border: "1px solid red" } : {}),
                    }}
                    value={formData?.dob}
                  />
                  {error?.dob && (
                    <p style={{ color: "red", fontSize: "10px" }}>
                      {error?.dob}
                    </p>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="form-group mb-3 col-md-6 form-builder-element">
                  <label htmlFor="">
                    Marital Status
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <div className="row">
                    <div className="custom-control custom-radio mx-2">
                      <input
                        id="married"
                        name="marital_status"
                        disabled={filledForm?.formStatusByHR}
                        type="checkbox"
                        className="custom-control-input form-view"
                        onChange={handleChange}
                        value="married"
                        checked={formData?.marital_status === "married"}
                      />
                      <label htmlFor="married" className="custom-control-label">
                        Married
                      </label>
                    </div>

                    <div className="custom-control custom-radio mx-2">
                      <input
                        id="unmarried"
                        name="marital_status"
                        type="checkbox"
                        disabled={filledForm?.formStatusByHR}
                        className="custom-control-input form-view"
                        onChange={handleChange}
                        checked={formData?.marital_status === "unmarried"}
                        value="unmarried"
                      />
                      <label
                        htmlFor="unmarried"
                        className="custom-control-label"
                      >
                        Unmarried
                      </label>
                    </div>
                    <div className="custom-control custom-radio mx-2">
                      <input
                        id="widow"
                        name="marital_status"
                        type="checkbox"
                        disabled={filledForm?.formStatusByHR}
                        className="custom-control-input form-view"
                        onChange={handleChange}
                        checked={formData?.marital_status === "widow"}
                        value="widow"
                      />
                      <label htmlFor="widow" className="custom-control-label">
                        Widow
                      </label>
                    </div>
                      <div className="custom-control custom-radio mx-2">
                      <input
                        id="epf_separated"
                        name="marital_status"
                        disabled={filledForm?.formStatusByHR}
                        type="checkbox"
                        className="custom-control-input form-view"
                        onChange={handleChange}
                        value="separated"
                        checked={formData?.marital_status === "separated"}
                      />
                      <label htmlFor="epf_separated" className="custom-control-label">
                        Separated
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group mb-3 col-md-4 form-builder-element">
                  <label htmlFor="">
                    Sex
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <div className="row">
                    <div className="custom-control custom-radio mx-3">
                      <input
                        id="male"
                        disabled={filledForm?.formStatusByHR}
                        name="sex"
                        type="checkbox"
                        className="custom-control-input form-view"
                        onChange={handleChange}
                        value="male"
                        checked={formData?.sex === "male"}
                      />
                      <label htmlFor="male" className="custom-control-label">
                        Male
                      </label>
                    </div>

                    <div className="custom-control custom-radio mx-3">
                      <input
                        disabled={filledForm?.formStatusByHR}
                        id="female"
                        name="sex"
                        type="checkbox"
                        className="custom-control-input form-view"
                        onChange={handleChange}
                        value="female"
                        checked={formData?.sex === "female"}
                      />
                      <label htmlFor="female" className="custom-control-label">
                        Female
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                {nominees.map((nominee, index) => {
                  if (nominee) {
                    row = row + 1;
                    return (
                      <Card
                        key={index}
                        title={
                          <div className="d-flex justify-content-between">
                            <span>{`Nominee ${row}`}</span>
                            <div>
                              {[...nominees.filter((nom) => nom !== null)]
                                .length !== 1 && (
                                <div className="col-1 ">
                                  <button
                                    className={`btn ${"btn-danger"} ml-4`}
                                    onClick={() => deleteNominee(index)}
                                  >
                                    <span className="pr-2">
                                      <i
                                        className="fa fa-trash"
                                        aria-hidden="true"
                                      ></i>
                                    </span>
                                    Delete
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        }
                      >
                        <div className="col-12">
                          <div className="row">
                            <div className="form-group col-md-4 form-builder-element mb-3">
                              <label htmlFor="">
                                Name And Address of the Nominee
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                className="form-control form-view"
                                type="text"
                                placeholder=""
                                name="name_and_address_of_nominee"
                                disabled={filledForm?.formStatusByHR}
                                onChange={(e) => handleChangeNominee(e, index)}
                                style={{
                                  ...(nomineeError[
                                    `name_and_address_of_nominee_${index}`
                                  ]?.index === index
                                    ? { border: "1px solid red" }
                                    : {}),
                                }}
                                value={nominee?.name_and_address_of_nominee.replaceAll(
                                  /\b[a-z]/g,
                                  (p) => p.toUpperCase()
                                )}
                              />
                              {nomineeError[
                                `name_and_address_of_nominee_${index}`
                              ]?.index === index && (
                                <p style={{ color: "red", fontSize: "10px" }}>
                                  {
                                    nomineeError[
                                      `name_and_address_of_nominee_${index}`
                                    ]?.message
                                  }
                                </p>
                              )}
                            </div>
                            <div className="form-group col-md-4 form-builder-element mb-3">
                              <label htmlFor="">
                                Nominee's Relationship With The Member
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                className="form-control form-view"
                                type="text"
                                placeholder=""
                                name="nominee_relationship"
                                disabled={filledForm?.formStatusByHR}
                                onChange={(e) => handleChangeNominee(e, index)}
                                style={{
                                  ...(nomineeError[
                                    `nominee_relationship_${index}`
                                  ]?.index === index
                                    ? { border: "1px solid red" }
                                    : {}),
                                }}
                                value={nominee?.nominee_relationship}
                              />
                              {nomineeError[`nominee_relationship_${index}`]
                                ?.index === index && (
                                <p style={{ color: "red", fontSize: "10px" }}>
                                  {
                                    nomineeError[
                                      `nominee_relationship_${index}`
                                    ]?.message
                                  }
                                </p>
                              )}
                            </div>

                            <div className="form-group col-md-4 form-builder-element mb-3">
                              <label htmlFor="">
                                Nominee's Date of Birth
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                className="form-control form-view"
                                type="date"
                                disabled={filledForm?.formStatusByHR}
                                name="date_of_birth"
                                max={formatDate(new Date())}
                                onChange={(e) => handleChangeNominee(e, index)}
                                style={{
                                  ...(nomineeError[`date_of_birth_${index}`]
                                    ?.index === index
                                    ? { border: "1px solid red" }
                                    : {}),
                                }}
                                value={nominee?.date_of_birth}
                              />
                              {nomineeError[`date_of_birth_${index}`]?.index ===
                                index && (
                                <p style={{ color: "red", fontSize: "10px" }}>
                                  {
                                    nomineeError[`date_of_birth_${index}`]
                                      ?.message
                                  }
                                </p>
                              )}
                            </div>
                            <div className="form-group col-md-4 form-builder-element mb-0 ">
                              <label htmlFor="">
                                Total amount of share of accumalation in
                                provident fund to be paid to forEach nominee
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                className="form-control form-view"
                                type="number"
                                disabled={filledForm?.formStatusByHR}
                                name="total_amount"
                                min={0}
                                onChange={(e) => handleChangeNominee(e, index)}
                                style={{
                                  ...(nomineeError?.total_amount &&
                                  nomineeError?.total_amount?.index === index
                                    ? { border: "1px solid red" }
                                    : {}),
                                }}
                                value={nominee?.total_amount}
                              />
                              {nomineeError?.total_amount &&
                                nomineeError?.total_amount?.index === index && (
                                  <p style={{ color: "red", fontSize: "10px" }}>
                                    {nomineeError?.total_amount?.message}
                                  </p>
                                )}
                            </div>
                            <div className="form-group col-md-5 form-builder-element mb-0">
                              <label htmlFor="">
                                If the nominee is minor name & address &
                                relationship of the guardian who may recive the
                                amount
                              </label>
                              <input
                                className="form-control form-view"
                                type="text"
                                disabled={filledForm?.formStatusByHR}
                                name="nominee_guardian_name_address"
                                onChange={(e) => handleChangeNominee(e, index)}
                                style={{
                                  ...(error?.nominee_guardian_name_address
                                    ? { border: "1px solid red" }
                                    : {}),
                                }}
                                value={nominee?.nominee_guardian_name_address}
                              />
                            </div>
                            {[...nominees.filter((nom) => nom !== null)]
                              .length < 5 &&
                              row ===
                                [...nominees.filter((nom) => nom !== null)]
                                  .length && (
                                <div className="form-group col-md-3 mb-0 form-builder-element  d-flex justify-content-end  align-items-end">
                                  <button
                                    className={`btn ${
                                      totalAmt >= 100
                                        ? "btn-secondary"
                                        : "btn-primary"
                                    }  ${"mt-2 mt-sm-0"} `}
                                    onClick={addMore}
                                    disabled={totalAmt >= 100}
                                  >
                                    <span className="pr-2">
                                      <i
                                        className="fa fa-plus"
                                        aria-hidden="true"
                                      ></i>
                                    </span>
                                    Add More
                                  </button>
                                </div>
                              )}
                          </div>
                        </div>
                      </Card>
                    );
                  }
                })}
              </div>
              {!nomineeGratuity?.documentDetails?.useNominee &&
              !nomineeWages?.documentDetails?.useNominee ? (
                <div className="row">
                  <div className="col-12 d-flex align-items-center gap-1 mt-4">
                    <input
                      type="checkbox"
                      id="epf_nominee"
                      checked={useNominee}
                      disabled={filledForm?.isFilledStatus}
                      onChange={(e) => {
                        setUseNominee(e.target.checked);
                      }}
                    />
                    <label htmlFor="epf_nominee" className="mb-0">
                      Check this box to apply nominee details to every form
                      automatically.
                    </label>
                  </div>
                </div>
              ) : (
                <></>
              )}
              <div className="row">
                <div className="col-12 d-flex justify-content-center mt-4">
                  <button
                    className={`btn ${
                      validateInput() ||
                      validateNominee() ||
                      filledForm?.formStatusByHR ||
                      IS_DISABLE
                        ? "btn-secondary"
                        : "btn-primary"
                    }`}
                    onClick={handleSubmit}
                    disabled={
                      validateInput() ||
                      validateNominee() ||
                      filledForm?.formStatusByHR ||
                      IS_DISABLE
                    }
                  >
                    <span className="pr-2">
                      <i className="fa fa-paper-plane" aria-hidden="true"></i>
                    </span>
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </Card>
    </>
  );
}

export default EPF;
